module.exports = __webpack_public_path__ + "static/media/Gemini_Generated_Image_b5qfgpb5qfgpb5qf.a1572a2b.png";